export default __webpack_public_path__ + "static/media/eh.414dbfef.svg";